<div *ngIf="countProgress && !countProgress.isFinal">
  <div>
    <mat-progress-bar
      width="100px"
      mode="determinate"
      [value]="countProgress.boothsPercent"
    ></mat-progress-bar>
    <span class="info"
      >{{ countProgress.boothsReported }} of
      {{ countProgress.boothsTotal }} polling booths</span
    >
    <span class="info">
      ({{ countProgress.boothsPercent / 100 | percent : "1.1-1" }})</span
    >
  </div>
  <div>
    <mat-progress-bar
      width="100px"
      mode="determinate"
      [value]="countProgress.earlyVotingCentresPercent"
    ></mat-progress-bar>
    <span class="info"
      >{{ countProgress.earlyVotingCentresReported }} of
      {{ countProgress.earlyVotingCentresTotal }} early voting centres</span
    >
    <span class="info">
      ({{
        countProgress.earlyVotingCentresPercent / 100 | percent : "1.1-1"
      }})</span
    >
  </div>
</div>
<div *ngIf="countProgress && countProgress.isFinal" class="info">
  The counting of votes for this election is now concluded. All votes have been
  counted and the results are final.
</div>
